package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.TuneW500Rounded: ImageVector
    get() {
        if (_tuneW500Rounded != null) {
            return _tuneW500Rounded!!
        }
        _tuneW500Rounded = Builder(name = "TuneW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(450.78f, 834.88f)
                quadToRelative(-12.69f, -12.53f, -12.69f, -31.05f)
                verticalLineToRelative(-160.24f)
                quadToRelative(0.0f, -18.53f, 12.69f, -31.06f)
                quadTo(463.48f, 600.0f, 481.91f, 600.0f)
                quadToRelative(18.44f, 0.0f, 31.01f, 12.53f)
                quadToRelative(12.58f, 12.53f, 12.58f, 31.06f)
                lineTo(525.5f, 680.0f)
                horizontalLineToRelative(276.41f)
                quadToRelative(18.53f, 0.0f, 31.06f, 12.58f)
                quadToRelative(12.53f, 12.57f, 12.53f, 31.01f)
                quadToRelative(0.0f, 18.43f, -12.53f, 31.13f)
                quadToRelative(-12.53f, 12.69f, -31.06f, 12.69f)
                lineTo(525.5f, 767.41f)
                verticalLineToRelative(36.42f)
                quadToRelative(0.0f, 18.52f, -12.58f, 31.05f)
                quadToRelative(-12.57f, 12.53f, -31.01f, 12.53f)
                quadToRelative(-18.43f, 0.0f, -31.13f, -12.53f)
                close()
                moveTo(158.09f, 767.41f)
                quadToRelative(-18.53f, 0.0f, -31.06f, -12.69f)
                quadToRelative(-12.53f, -12.7f, -12.53f, -31.13f)
                quadToRelative(0.0f, -18.44f, 12.53f, -31.01f)
                quadTo(139.56f, 680.0f, 158.09f, 680.0f)
                horizontalLineToRelative(160.24f)
                quadToRelative(18.52f, 0.0f, 31.05f, 12.58f)
                quadToRelative(12.53f, 12.57f, 12.53f, 31.01f)
                quadToRelative(0.0f, 18.43f, -12.53f, 31.13f)
                quadToRelative(-12.53f, 12.69f, -31.05f, 12.69f)
                lineTo(158.09f, 767.41f)
                close()
                moveTo(287.2f, 590.89f)
                quadToRelative(-12.7f, -12.69f, -12.7f, -31.13f)
                verticalLineToRelative(-36.17f)
                lineTo(158.09f, 523.59f)
                quadToRelative(-18.53f, 0.0f, -31.06f, -12.58f)
                quadTo(114.5f, 498.43f, 114.5f, 480.0f)
                reflectiveQuadToRelative(12.53f, -31.01f)
                quadToRelative(12.53f, -12.58f, 31.06f, -12.58f)
                lineTo(274.5f, 436.41f)
                lineTo(274.5f, 400.0f)
                quadToRelative(0.0f, -18.52f, 12.7f, -31.06f)
                quadToRelative(12.69f, -12.53f, 31.13f, -12.53f)
                quadToRelative(18.43f, 0.0f, 31.01f, 12.53f)
                quadToRelative(12.57f, 12.54f, 12.57f, 31.06f)
                verticalLineToRelative(160.0f)
                quadToRelative(0.0f, 18.52f, -12.57f, 31.06f)
                quadToRelative(-12.58f, 12.53f, -31.01f, 12.53f)
                quadToRelative(-18.44f, 0.0f, -31.13f, -12.7f)
                close()
                moveTo(481.67f, 523.59f)
                quadToRelative(-18.52f, 0.0f, -31.05f, -12.58f)
                quadToRelative(-12.53f, -12.58f, -12.53f, -31.01f)
                reflectiveQuadToRelative(12.53f, -31.01f)
                quadToRelative(12.53f, -12.58f, 31.05f, -12.58f)
                horizontalLineToRelative(320.24f)
                quadToRelative(18.53f, 0.0f, 31.06f, 12.58f)
                quadTo(845.5f, 461.57f, 845.5f, 480.0f)
                reflectiveQuadToRelative(-12.53f, 31.01f)
                quadToRelative(-12.53f, 12.58f, -31.06f, 12.58f)
                lineTo(481.67f, 523.59f)
                close()
                moveTo(610.78f, 347.47f)
                quadToRelative(-12.69f, -12.53f, -12.69f, -31.06f)
                verticalLineToRelative(-160.24f)
                quadToRelative(0.0f, -18.52f, 12.69f, -31.05f)
                quadToRelative(12.7f, -12.53f, 31.13f, -12.53f)
                quadToRelative(18.44f, 0.0f, 31.01f, 12.53f)
                quadToRelative(12.58f, 12.53f, 12.58f, 31.05f)
                verticalLineToRelative(36.42f)
                horizontalLineToRelative(116.41f)
                quadToRelative(18.53f, 0.0f, 31.06f, 12.57f)
                quadToRelative(12.53f, 12.58f, 12.53f, 31.01f)
                quadToRelative(0.0f, 18.44f, -12.53f, 31.13f)
                quadToRelative(-12.53f, 12.7f, -31.06f, 12.7f)
                lineTo(685.5f, 280.0f)
                verticalLineToRelative(36.41f)
                quadToRelative(0.0f, 18.53f, -12.58f, 31.06f)
                quadTo(660.35f, 360.0f, 641.91f, 360.0f)
                quadToRelative(-18.43f, 0.0f, -31.13f, -12.53f)
                close()
                moveTo(158.09f, 280.0f)
                quadToRelative(-18.53f, 0.0f, -31.06f, -12.7f)
                quadToRelative(-12.53f, -12.69f, -12.53f, -31.13f)
                quadToRelative(0.0f, -18.43f, 12.53f, -31.01f)
                quadToRelative(12.53f, -12.57f, 31.06f, -12.57f)
                horizontalLineToRelative(320.24f)
                quadToRelative(18.52f, 0.0f, 31.05f, 12.57f)
                quadToRelative(12.53f, 12.58f, 12.53f, 31.01f)
                quadToRelative(0.0f, 18.44f, -12.53f, 31.13f)
                quadToRelative(-12.53f, 12.7f, -31.05f, 12.7f)
                lineTo(158.09f, 280.0f)
                close()
            }
        }
        .build()
        return _tuneW500Rounded!!
    }

private var _tuneW500Rounded: ImageVector? = null
